import { MAX_FILE_SIZE_BYTES } from '../utils/constants'

export enum FilesSelectErrors {
  FILE_SIZE_TOO_LARGE = 'file-size-too-large',
  TOO_MANY_FILES = 'too-many-files',
  TOO_MANY_FEATURED_IMAGES = 'too-many-featured-images',
}

export const useFileValidityCheck = () => {
  const isFileValid = (
    file: File
  ): {
    isValid: boolean
    error?: FilesSelectErrors
  } => {
    if (file.size > MAX_FILE_SIZE_BYTES) {
      return { isValid: false, error: FilesSelectErrors.FILE_SIZE_TOO_LARGE }
    }
    return { isValid: true }
  }
  return { isFileValid }
}
